import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

@Component({
  selector: 'app-orderchart',
  templateUrl: './orderchart.component.html',
  styleUrls: ['./orderchart.component.scss']
})
export class OrderchartComponent implements OnInit {

  private randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  private orderChart;

  constructor() { }

  ngOnInit(): void {
    this.initOrderChart();
    this.refreshOrderChart();
  }

  refreshOrderChart() {
    if(this.orderChart.data.datasets[0].data.length == 5) {
      this.orderChart.data.datasets[0].data.splice(4,1);
    }

    let randomNumber = this.randomInt(0, 5);
    if(this.orderChart.data.datasets[0].data.length == 0)
      this.orderChart.data.datasets[0].data.push(randomNumber);
    else {
      let tmp = [randomNumber];
      this.orderChart.data.datasets[0].data = tmp.concat(this.orderChart.data.datasets[0].data);
    }

    this.orderChart.update();
  }

  initOrderChart() {
    this.orderChart = new Chart("orderChart", {
      type: 'line',
      data: {
          labels: ['Aktivität 1', 'Aktivität 2', 'Aktivität 3', 'Aktivität 4', 'Aktivität 5'],
          datasets: [{
              label: 'Anzahl Bestellungen',
              data: [],
              backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)'
              ],
              borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)'
              ],
              borderWidth: 3
          }]
      },
      options: {
          scales: {
              y: {
                  beginAtZero: true
              }
          }
      }
    });
  }
}
